import LinearProgress from '@mui/material/LinearProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import styles from './BotaoProgresso.module.css'

export default function BotaoProgresso({ value }) {
    const progresso = typeof value === 'number' && !isNaN(value) ? value : 0

    return (
        <Box className={styles.container}>
            <Box className={styles.bar}>
                <LinearProgress
                    variant="determinate"
                    value={progresso}
                    className={styles.linear}
                />
            </Box>
            <Box className={styles.label}>
                <Typography variant="body2">
                    {`${value}% Concluído`}
                </Typography>
            </Box>
        </Box>
    )
}
